module.exports = __webpack_public_path__ + "img/fuison5-detail.b75d051c.webp";